module.exports = __webpack_public_path__ + "static/media/after-your-appointment-at-home-03-1-x@3x.16b1c077.jpg";